<template>
  <v-dialog v-model="modelObs" width="700px" v-on:update:modelValue="fechar">
    <v-btn icon="mdi-close" size="x-small" class="btn-close" @click="fechar"></v-btn>
    <v-card v-if="item != null" class="pa-6">
      <v-card-title class="pa-0">{{ item.name }}</v-card-title>
      <v-card-text class="pa-0 py-4">
        <v-row>
          <v-col>
            <v-form ref="obs" lazy-validation>
              <v-textarea :rules="[rules.required]" label="Observação" variant="outlined" v-model="obs"></v-textarea>
            </v-form>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-0">
            <v-btn variant="flat" block class="bg-color-0 text-white" @click="fechar()">CANCELAR</v-btn>
          </v-col>
          <v-col class="py-0">
            <v-btn variant="flat" block class="bg-color-2 text-white" @click="comentar()" :disabled="disabled">COMENTAR</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions } from 'vuex';
export default {
  name: 'DialogObs',
  data(){
    return {
      modelObs: false,
      obs: "",
      disabled: false,
      rules: {
        required: v => !!v || 'Este campo é obrigatório.',
      },
    }
  },
  props: {
    item: {
      type: Object,
      default: null,
      required: true
    },
    model: {
      type: Boolean,
      default: false,
      required: true
    },
    fechar: {
      type: Function,
      default: null,
      required: true
    }
  },
  watch: {
    model() {
      this.modelObs = this.model;
    },
    item(i) {
      this.obs = i.cart.obs;
    }
  },
  methods: {
    ...mapActions('cart', {
      updateItemObs: 'updateItemObs',
    }),
    async comentar(){
      const { valid } = await this.$refs.obs.validate();
      if (valid){
        this.disabled = true;
        this.updateItemObs({ sku: this.item.sku, obs: this.obs}).then(function(response){
          this.disabled = false;
          this.emitter.emit('dialogMessage', { title: response.cod == 200? "Sucesso!":"Ops!", message: response.msg});
          this.fechar();
        }.bind(this));
      }
    }
  },
  mounted(){
    this.obs = this.item.cart.obs;
  }
}
</script>